import { apiGateway } from "../config";

export type BillingRequestsParams = {
    seller_uuid: string;
    platform?: string;
    status?: number;
    from?: string;
    to?: string;
    limit?: number;
};

export type BillingRequestItem = {
    marketplace_platform: string;
    status: number;
    query_pattern: string;
    count: number;
    total_cost: number;
};

const getHeaders = (): HeadersInit => {
    const apiKey = process.env.REACT_APP_BILLING_API_KEY;
    return apiKey ? { Authorization: `Bearer ${apiKey}` } : {};
};

class BillingService {
    async getRequests(params: BillingRequestsParams): Promise<{ data: BillingRequestItem[] }> {
        const query = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                query.append(key, String(value));
            }
        });

        const response = await fetch(
            `${apiGateway.billing}/requests?${query.toString()}`,
            { headers: getHeaders() }
        );

        if (!response.ok) {
            throw new Error(`${response.status} ${response.statusText}`);
        }

        return response.json();
    }
}

export default new BillingService();
